export default "__VITE_ASSET__baf87d8c__"